import * as React from 'react';
export const bancorpSvg = React.forwardRef(function bancorpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#91BC2D',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M24.07 7.82c2.4 0 3.4 1.17 3.6 2.34.2 1.16-1.8 3.3-1.8 3.3s-.8-1.36-2.8-.58c0 0 0 .2.8-1.95.8-2.14-3.58-1.75-4.98-1.55-1.4.2-3.99.78-8.77 3.7 3.79-2.92 10.36-5.65 13.95-5.26zM7.92 24.17c-2.39 0-3.38-1.17-3.58-2.34-.2-1.17 2.19-3.89 2.19-3.89s.6 1.75 2.4 1.17c0 0 0-.2-.8 1.94s3.58 1.76 4.98 1.56c1.4-.2 3.99-.97 8.77-3.9-4.78 3.9-10.37 5.85-13.96 5.46z',
      }),
    ),
  );
});
bancorpSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bancorp = {
  category: 'brand',
  colorable: false,
  name: 'bancorp',
  svg: bancorpSvg,
};
